interface TimedNote {
  created: string;
  occurred_at?: string | null;
}

export default function getNoteTime(note: TimedNote): string {
  return note.occurred_at ?? note.created;
}
